import * as React from "react";
import { Form, useFormApi } from "informed";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Required } from "../../../../forms/validation/Required";
import { TextArea } from "../../../../forms/informedv2/TextArea";

export interface MiscCorrectionFormModal {
    originalEntry: string;
    newEntry: string;
}

export interface MiscCorrectionFormProps {
    onNext: (form: MiscCorrectionFormModal) => void;
    originalEntry: string;
    newEntry: string;
}

export const MiscCorrectionForm = ({ onNext, originalEntry, newEntry }: MiscCorrectionFormProps) => {
    const formApi = useFormApi<MiscCorrectionFormModal>();

    const onSubmit = () => {
        formApi.validate();

        const formState = formApi.getState();
        onNext(formState.values);
    }

    const originalEntryTooltip = (
        <Tooltip id="originalEntryTooltip" style={{ zIndex: 2500 }}>
            Enter data exactly how it appears in the system
        </Tooltip>
    );

    const newEntryTooltip = (
        <Tooltip id="newEntryTooltip" style={{ zIndex: 2500 }}>
            Enter data as it should appear once the correction has been applied
        </Tooltip>
    );

    return (
        <Form initialValues={{ originalEntry: originalEntry, newEntry: newEntry }} onSubmit = { onNext }>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Request your data correction below giving as much detail as possible to
                            make it clear what is required to perform the correction
                        </p>
                        <div className="form-group col-md-6">
                            <label htmlFor="originalEntry">Original Entry</label>&nbsp;
                            <OverlayTrigger placement="top" overlay={originalEntryTooltip}>
                                <i aria-hidden="true" className="fa fa-info-circle text-muted" />
                            </OverlayTrigger>
                            <TextArea
                                id="originalEntry"
                                field="originalEntry"
                                className="form-control"
                                validate={Required}
                                validateOnBlur
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="newEntry">Entry to be changed to</label>
                            &nbsp;
                            <OverlayTrigger placement="top" overlay={newEntryTooltip}>
                                <i aria-hidden="true" className="fa fa-info-circle text-muted" />
                            </OverlayTrigger>
                            <TextArea
                                id="newEntry"
                                field="newEntry"
                                className="form-control"
                                validate={Required}
                                validateOnBlur
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="submit" onSubmit={onSubmit}>
                    Next
                </button>
            </div>
        </Form>
    );
};
